module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myBill"
    }
  }, [_c('mt-header', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "title": "我的发票"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/mine"
    },
    slot: "left"
  }, [_c('mt-button', [_c('img', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "slot": "icon",
      "src": require("../../../assets/icon/back.png"),
      "height": "auto",
      "width": "8px"
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#d8d8d8"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "myBill-content-detail"
    }
  }, [_vm._v("\n    发票业务正在升级中......\n  ")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "myBill-content-detail2"
    }
  }, [_vm._v("\n    您可通过以下两种方式进行发票申请"), _c('br'), _vm._v("\n    1.  电脑访问www.blissmall.net，点击页面底部“发票申请”进入 "), _c('br'), _vm._v("\n    2.  拨打客服电话400-999-6666进行人工申请"), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19433487","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mine/myBill/myBill.vue
// module id = 551
// module chunks = 1